var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex flex-column h-100",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
                _vm._v("art_track"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase",
                },
                [_vm._v(_vm._s(_vm.$t("app.videoPlaylists")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "pl-0 pr-0",
              attrs: { text: "", small: "", to: `/video-playlists` },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "white--text text-decoration-underline font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "ml-1", attrs: { small: "", color: "white" } },
                [_vm._v("keyboard_arrow_right")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "d-flex flex-column pb-1 flex-grow-1" },
        [
          !_vm.loading
            ? [
                _c("v-data-table", {
                  staticClass: "pa-0",
                  attrs: {
                    dense: "",
                    "disable-items-per-page": "",
                    headers: _vm.headers,
                    items: _vm.playlists,
                    "footer-props": {
                      itemsPerPageOptions: _vm.$vuetify.breakpoint.smAndDown
                        ? [1]
                        : [6],
                    },
                    loading: _vm.loading,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.name",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/video-highlights/playlist/${item.id}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-weight-medium primary--text body-1",
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.createdTime",
                        fn: function ({ item }) {
                          return [
                            _c("span", { staticClass: "body-1" }, [
                              _vm._v(_vm._s(item.createdAt)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.usedTime",
                        fn: function ({ item }) {
                          return [
                            _c("span", { staticClass: "body-1" }, [
                              _vm._v(_vm._s(item.usedAt)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    212010999
                  ),
                }),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(4, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
          _vm._v(" "),
          _c("v-divider", { staticClass: "mt-1" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }